export enum AddressParity {
	Undefined = 0,
	Odd = 1,
	Even = 2
}

export default AddressParity;
